import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: '📊' },
    { path: '/analytics', label: 'Analytics', icon: '📈' },
    { path: '/wrapped-2025', label: '2025 Wrapped', icon: '🎊' },
    { path: '/user-acquisition', label: 'User Sources', icon: '🎯' },
    { path: '/promo-codes', label: 'Promo Codes', icon: '🎟️' },
    { path: '/activation-funnel', label: 'Activation Funnel', icon: '🔄' },
    { path: '/onboarding', label: 'Onboarding', icon: '🧩' },
    { path: '/users', label: 'Users', icon: '👥' },
    { path: '/fitnesses', label: 'Fitness Goals', icon: '⚡' },
    { path: '/foods', label: 'Food Logs', icon: '🍽️' },
    { path: '/scanned-foods', label: 'Scanned Foods', icon: '📸' },
    { path: '/weights', label: 'Weights', icon: '⚖️' },
    { path: '/activities', label: 'Activities', icon: '🏃' },
    { path: '/measurements', label: 'Measurements', icon: '📏' },
    { path: '/teams', label: 'Teams', icon: '🤝' },
    { path: '/assistant', label: 'AI Chats', icon: '💬' },
    { path: '/assistant/insights', label: 'AI Chats — Insights', icon: '🧠' },
    { path: '/assistant/users', label: 'AI Chats — Users', icon: '🧑‍💻' },
    { path: '/ai-prompts', label: 'AI Prompts', icon: '📝' },
    { path: '/mcp', label: 'MCP Server', icon: '🔌' },
    { path: '/health', label: 'Health', icon: '🩺' },
    { path: '/settings', label: 'Settings', icon: '⚙️' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className={`layout ${location.pathname === '/weights' ? 'layout-weights' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="logo">KKAL Admin</h1>
          <p className="logo-subtitle">Fitness Data Panel</p>
          <p className="last-update">Last update: Jan 15, 2026</p>
        </div>
        <nav className="nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path || (item.path === '/ai-prompts' && location.pathname.startsWith('/ai-prompts/')) ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-icon">👤</span>
            <span className="user-name">{user?.username || 'Admin'}</span>
          </div>
          <button onClick={handleLogout} className="logout-button">
            <span className="logout-icon">🚪</span>
            Logout
          </button>
        </div>
      </aside>
      <main className="main-content">
        <div className="container">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
